import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Forge = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 32 21"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
      fill={fill}
    >
      <g fill="none" fillRule="nonzero">
        <path fill="#C82E24" d="M11.709 0H32L11.732 20.268z" />
        <path fill="#A8272A" d="M9.208 2.526v9.218L0 2.536z" />
        <path fill="#8D1A18" d="m19.401 16.178 4.09 4.09H15.32z" />
        <path fill="#E43025" d="M9.208 20.268H3.2l6-6.001z" />
      </g>
    </svg>
  );
};

Forge.displayName = 'Forge';
